import {
  PanelsState,
  PanelsReducerActions,
  PanelsActions,
} from '../types/panels-state.js';
import { Panels } from '../types/shared-panel-types.js';

const checkForDuplicates = (state: Panels, name: string | number) => {
  const panel = state[name];
  if (panel) {
    throw new Error(
      'There are duplicated panel names, which will overwrite each other. Please use a unique name for each Panel.',
    );
  }
};

/** Panels reducer function used for managing the state of the panels. */
export function panelsReducer(
  state: PanelsState,
  action: PanelsReducerActions,
): PanelsState {
  const { type, payload } = action;
  let newState: PanelsState = { ...state };

  const { name } = payload;

  // ADD Panel
  if (type === PanelsActions.ADDPANEL) {
    checkForDuplicates(state.panels, name);
    const { name: _, ...panelState } = payload;

    newState = {
      resizeHandles: state.resizeHandles,
      panels: {
        ...state.panels,
        [name]: panelState,
      },
    };

    return newState;
  }

  // UPDATE Panel
  if (type === PanelsActions.UPDATEPANEL) {
    newState = {
      resizeHandles: state.resizeHandles,
      panels: {
        ...state.panels,
        [name]: {
          ...state.panels[name],
          ...payload,
        },
      },
    };

    return newState;
  }

  // REMOVE Panel
  if (type === PanelsActions.REMOVEPANEL) {
    delete state.panels[name];

    return { ...state };
  }

  // ADD Resize handle
  if (type === PanelsActions.ADDRESIZEHANDLE) {
    newState.resizeHandles[name] = {
      order: payload.order,
    };

    return newState;
  }

  // REMOVE Resize handle
  if (type === PanelsActions.REMOVERESIZEHANDLE) {
    delete state.resizeHandles[name];

    return { ...state };
  }

  return state;
}
